import { Row } from 'antd';
import { useState } from 'react';
import { reportLabel, reportOptions } from '../../../../constants';
import { CustomSelect } from '../../../uiComponents';
import { CosmetologicFeesByCosmetologistReport } from '../CosmetologicFeesByCosmetologist';
import { DailyCashClosingReport } from '../DailyCashClosingReport';
import { DailySalesReport } from '../DailySalesReport';
import { ExpensesbyBranchReport } from '../ExpensesByBranchReport';
import { GeneralAppointmentReport } from '../GeneralAppointmentReport';
import { GeneralCosmetologicFeesReport } from '../GeneralCosmetologicFeesReport';
import { GeneralCustomerReport } from '../GeneralCustomerReport';
import { GeneralExpensesReport } from '../GeneralExpensesReport';
import { GeneralInventoryReport } from '../GeneralInventoryReport';
import { GeneralShcedulAppointments } from '../GeneralShcedulAppointments';
import { ComissionMedicalIndividualReport } from '../IndividualCommissionMedicalReport';
import { MedicalCommissionsByBranchReport } from '../MedicalCommissionByBranchReport';
import { MonthlySales } from '../MonthySales';
import { AppointmentConfirmationPercentageReportByBranch } from '../AppointmentConfirmationPercentageReportByBranch';
import { ProfitabilityByBranchReport } from '../ProfitabilityByBranchReport';
import { StockByBranchReport } from '../StockByBranchReport';
import { OccupationByBranchReport } from '../OccupationByBranchReport';
import './style.css';

export const ReportsFilters = () => {
  const [report, setReport] = useState(reportLabel.profitabilityReport);

  const reportsDictionary = {
    [reportLabel.generalInventory]: <GeneralInventoryReport />,
    [reportLabel.branchInventory]: <StockByBranchReport />,
    [reportLabel.productConsumption]: <GeneralExpensesReport />,
    [reportLabel.productConsumptionBranch]: <ExpensesbyBranchReport />,
    [reportLabel.generalCustomer]: <GeneralCustomerReport />,
    [reportLabel.generalAppointment]: <GeneralAppointmentReport />,
    [reportLabel.generalCosmetologicFees]: <GeneralCosmetologicFeesReport />,
    [reportLabel.cosmetologicFeesByCosmetologist]: (
      <CosmetologicFeesByCosmetologistReport />
    ),
    [reportLabel.medicalCommissionsByBranchReport]: (
      <MedicalCommissionsByBranchReport />
    ),
    [reportLabel.generalShcedulAppointments]: <GeneralShcedulAppointments />,
    [reportLabel.individualCommissionMedical]: (
      <ComissionMedicalIndividualReport />
    ),
    [reportLabel.appointmentConfirmationPercentageByBranch]: (
      <AppointmentConfirmationPercentageReportByBranch />
    ),
    [reportLabel.dailySalesReport]: <DailySalesReport />,
    [reportLabel.monthlySales]: <MonthlySales />,
    [reportLabel.dailyCashClosingReport]: <DailyCashClosingReport />,
    [reportLabel.profitabilityReport]: <ProfitabilityByBranchReport />,
    [reportLabel.occupationByBranch]: <OccupationByBranchReport />,
  };

  return (
    <>
      <Row justify="start" align="middle">
        <CustomSelect
          style={{ width: '420px', marginBottom: '20px' }}
          options={reportOptions}
          onChange={setReport}
          defaultValue={reportLabel.profitabilityReport}
        />
      </Row>
      <Row
        justify="center"
        style={{ overflow: 'scroll', height: '100%' }}
        className="report-container"
      >
        {reportsDictionary[report]}
      </Row>
    </>
  );
};
